const validateProjectDetails = (
    {projectType,
      academicStartYear,
      deadline,
      division,
      groupNumber,
      projectContributorIds,
      projectDevelopmentDepartment,
      projectYearOfDevelopment,
      semester,
    }) => {

    const errors = {};

    switch(projectType) {
        case "EDAI":
            if(academicStartYear === "") {
                errors.academicStartYear = "Please enter start of academic year"
            } 
            
            if(deadline === "") {
                errors.deadline = "Please select a deadline"
            }

            if(division === "") {
                errors.division = "Please enter a division"
            }

            if(groupNumber === "") {
                errors.groupNumber = "Please enter a group no"
            }

            if(projectContributorIds.length === 1) {
                errors.noOfContributors = "No of students in the EDAI should be atleast 2";
            }

            const studentGrNos = []; 
            for(let index=0; index<projectContributorIds.length; index+=1) {
                if(projectContributorIds[index] === "") {
                    studentGrNos.push("Please enter GR No for student");
                }
            }
            if(studentGrNos.length > 0) {
                errors.studentGrNos = studentGrNos;
            }

            if(projectDevelopmentDepartment === "") {
                errors.projectDevelopmentDepartment = "Please select a department"
            }

            if(projectYearOfDevelopment === "") {
                errors.projectYearOfDevelopment = "Please select a year"
            }

            if(semester === "") {
                errors.semester = "Please select a semester"
            }

            break;
        case "SDP": 
            if(academicStartYear === "") {
                errors.academicStartYear = "Please enter start of academic year"
            } 
            
            if(deadline === "") {
                errors.deadline = "Please select a deadline"
            }

            if(division === "") {
                errors.division = "Please enter a division"
            }

            const [studentGrNo] = projectContributorIds;

            if(studentGrNo === "") {
                errors.studentGrNo = "Please enter GR No of the student"
            }

            if(projectDevelopmentDepartment === "") {
                errors.projectDevelopmentDepartment = "Please select a department"
            }

            if(projectYearOfDevelopment === "") {
                errors.projectYearOfDevelopment = "Please select a year"
            }

            if(semester === "") {
                errors.semester = "Please select a semester"
            }
            
            break;
        default:
            errors.anonymous = "Something wrong happened"
    }

    return errors;
}

export default validateProjectDetails;